import SearchResultsContainer from './SearchResult';

export default SearchResultsContainer;
